import * as React from 'react'

import { observer } from 'mobx-react'

import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import AddonButton from './AddonButton'
import IntegrationButton from './IntegrationButton'

interface Props {
  subscriptionAddon: SubscriptionAddon
}

const CTAButton = ({ subscriptionAddon }: Props) => {
  if (subscriptionAddon.isApp) {
    return <AddonButton subscriptionAddon={subscriptionAddon} />
  }

  return <IntegrationButton subscriptionAddon={subscriptionAddon} />
}

export default observer(CTAButton)
